import { BaseTextMergeEditor } from "../BaseTextMergeEditor";
import { BaseTextMergeElement } from "../../../rule-engine-core/TextMerge/Elements/BaseTextMergeElement";
import { TextMergeEditContext } from "../../../rule-engine-core/TextMerge/TextMergeEditContext";
import { Box } from "@mui/material";
import { InlineTextEdit } from "../../../CommonUI/InlineEditor/InlineTextEdit";
import { ExpressionView, ExpressionViewEmptyBehavior } from "../../../Expressions/ExpressionView";
import React from "react";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { BaseJSONXMLElement } from "../../../rule-engine-core/TextMerge/Elements/JSONXML/BaseJSONXMLElement";
import { TextMergeType } from "../../../rule-engine-core/TextMerge/TextMergeType";
import { UILabel } from "../../../CommonUI/BuildlingBlocks/UILabel";

export abstract class BaseJSONXMLElementEditor<T extends BaseJSONXMLElement> extends BaseTextMergeEditor<T> {
    renderDisplay(config: BaseTextMergeElement, editContext: TextMergeEditContext): React.ReactNode {
        if (editContext.definition.type === TextMergeType.XML) {
            return (
                <span
                    style={
                        editContext.selectedElement?.id === this.getEditorData().id
                            ? { background: UIStyleConstants.BLUE_LIGHT_COLOR }
                            : {}
                    }
                    onClick={() => {
                        editContext.setSelectedElement(config);
                    }}
                >
                    {DataUtilities.getIndent(config.getDepth())}
                    {"<" + this.editorData?.fieldName + ">"} [!Field!] {"</" + this.editorData?.fieldName + ">"}
                    <br />
                </span>
            );
        } else {
            // JSON
            return (
                <span
                    style={
                        editContext.selectedElement?.id === this.getEditorData().id
                            ? { background: UIStyleConstants.BLUE_LIGHT_COLOR }
                            : {}
                    }
                    onClick={() => {
                        editContext.setSelectedElement(config);
                    }}
                >
                    {DataUtilities.getIndent(config.getDepth())}"{this.editorData?.fieldName}" : [!Field!] <br />
                </span>
            );
        }
    }

    renderEditor(config: BaseTextMergeElement, editContext: TextMergeEditContext): React.ReactNode {
        return (
            <Box
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                padding={"3px"}
                margin={"3px"}
                bgcolor={"white"}
                border={editContext.selectedElement?.id === config.id ? "2px solid red" : "1px solid blue"}
                onClick={() => {
                    editContext.setSelectedElement(config);
                }}
            >
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                >
                    <UILabel>Name: </UILabel>
                    <InlineTextEdit
                        text={this.editorData!.fieldName}
                        onEdit={(newText) => {
                            this.editorData!.fieldName = newText;
                        }}
                    ></InlineTextEdit>
                </Box>
                <ExpressionView
                    emptyBehavior={ExpressionViewEmptyBehavior.VARIABLE}
                    expression={this.editorData!.value}
                />
            </Box>
        );
    }
}
